import { render, staticRenderFns } from "./EducatorReviewsDashboard.vue?vue&type=template&id=4a622058&scoped=true"
import script from "./EducatorReviewsDashboard.vue?vue&type=script&lang=js"
export * from "./EducatorReviewsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a622058",
  null
  
)

export default component.exports